import { SubscriptionClient } from 'subscriptions-transport-ws';
import { Observable, ObservableFromValue } from 'relay-runtime';
import {
  ConcreteBatch,
  Variables,
  QueryPayload,
  RelayObservable,
} from 'react-relay-network-modern/es';

const createSubscribeFn = (authToken: string, endpoint: string) => {
  const subscriptionClient = new SubscriptionClient(endpoint, {
    reconnect: true,
    connectionParams: {
      'x-token': authToken,
    },
  });

  const subscribe = (operation: ConcreteBatch, variables: Variables) => {
    const subscribeObservable = subscriptionClient.request({
      query: operation.text || undefined,
      operationName: operation.name,
      variables,
    }) as ObservableFromValue<QueryPayload>;

    return (Observable.from(subscribeObservable) as unknown) as RelayObservable<QueryPayload>;
  };
  return { subscribe, closeClientConnection: subscriptionClient.close.bind(subscriptionClient) };
};

export default createSubscribeFn;
